import React from 'react'
import { Cta } from '@components'

const DatoCmsCta = ({ heading, content, button }) => {
  return <Cta heading={heading} content={content} link={button} />
}

export default DatoCmsCta
